import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { UploadFile } from "antd";
import { AxiosRequestConfig } from "axios";
import { useAuthenticatedRequest, useAuthenticatedRequestCreator } from "hooks/useRequests";
import { CardTitleCsvImport } from "models/cardIngestion";

const HistoryLength = 5;
const QueryKeyPrefix = ["card-titling", "import-csv", "recent"];

const useCardTitleCsvImport = (polling: boolean = false) => {
    const queryClient = useQueryClient();

    const axiosRequestConfig = (file: UploadFile): AxiosRequestConfig => {
        const formData = new FormData();
        formData.append("csv", file.originFileObj!);

        return {
            method: "post",
            url: "/card-titling/import-csv",
            data: formData,
            headers: {
                "Content-Type": "multipart/form-data",
            },
        }
    }

    const { mutateAsync: uploadCsv, isLoading: isUploading } = useMutation(
        useAuthenticatedRequestCreator(axiosRequestConfig, [400])
    );

    const { data: history, isLoading } =
        useQuery([...QueryKeyPrefix, HistoryLength], useAuthenticatedRequest<CardTitleCsvImport[]>({
            method: "get",
            url: `/card-titling/import-csv/recent?count=${HistoryLength}`
        }));

    const { data: latest = [] } =
        useQuery([...QueryKeyPrefix, 1], useAuthenticatedRequest<CardTitleCsvImport[]>({
            method: "get",
            url: "/card-titling/import-csv/recent?count=1"
        }), {
            refetchInterval: polling ? 1000 : false
        });

    const refetchHistory = async () => {
        await queryClient.invalidateQueries(QueryKeyPrefix);
    }

    return {
        latest: latest[0],
        history,
        refetchHistory,
        uploadCsv,
        isLoading,
        isUploading
    };
};

export default useCardTitleCsvImport;